import React from 'react';
import { string } from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { Hydrator } from '@thd-olt-component-react/hydrator';
import { RelatedSearch } from '@thd-olt-component-react/related-search';

import classnames from 'classnames/bind';
import componentStyles from './components.module.scss';

const styles = classnames.bind(componentStyles);

const PopularCategoriesPropTypes = {
  id: string,
};

const PopularCategoriesDefaultProps = {
  id: undefined,
};

export function CustomRenderedPopularCategories({
  SCROLL_BUFFER,
  HOMEPAGE_DELAY_STANDARD,
  PLACEHOLDER,
}) {
  function PopularCategories({ id }) {
    return (
      <QueryProvider key={id} cacheKey={id}>
        <Hydrator
          id="popularCategories-php-hydrator"
          className={styles('u-height-100')}
          scrollBuffer={SCROLL_BUFFER}
          delay={HOMEPAGE_DELAY_STANDARD}
          placeholder={PLACEHOLDER}
        >
          <RelatedSearch isPopularCategory />
        </Hydrator>
      </QueryProvider>
    );
  }

  PopularCategories.propTypes = PopularCategoriesPropTypes;
  PopularCategories.defaultProps = PopularCategoriesDefaultProps;

  return PopularCategories;
}
